export default {
  Lessons: {
    Lesson: "Lesson",
    status: {
      success: "Completed",
      unsuccess: "Not Completed",
      stop: "Unavailable",
    },
  },
};
